import clsx from 'clsx'

import type { SizeType } from '@wartek-id/button-v1'
import { Button } from '@wartek-id/button-v1'

interface Props<T> {
  activeValue?: T
  items: {
    label: string
    value: T
  }[]
  onChange?: (value: T) => any
  btnSize?: SizeType
  disabled?: boolean
  className?: string
}

const FilterButtons = <T,>({
  activeValue,
  items,
  btnSize = 'md',
  onChange = () => {},
  className,
  disabled = false,
}: Props<T>) => {
  return (
    <div className={clsx('flex gap-4', className)} role="listbox">
      {items.map(({ label, value }) => (
        <Button
          key={`filter-button-${value}`}
          className={clsx(
            '!rounded-full',
            JSON.stringify(activeValue) === JSON.stringify(value) &&
              !disabled &&
              '!text-blue-70 !outline-blue-70 !bg-[#F2F8FE]'
          )}
          role="option"
          size={btnSize}
          aria-selected={JSON.stringify(activeValue) === JSON.stringify(value)}
          color="white"
          onClick={() => onChange(value)}
          disabled={disabled}
        >
          {label}
        </Button>
      ))}
    </div>
  )
}

export default FilterButtons
